import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4-mini";

import { AlertType, alertTypeSchema } from "@/models/AlertModel.ts";
import { PatientSettingsPage } from "@/uiKit/pages/PatientSettingsPage.tsx";
import { Schema, cz } from "@/utils/zodUtils.ts";

type SearchOptions = {
  alert?: AlertType;
  to?: string;
};

const searchOptionsSchema: Schema<SearchOptions> = z.object({
  alert: cz.optional(alertTypeSchema),
});

export const Route = createFileRoute("/_practitioner/patients/$patientId/settings")({
  validateSearch: (search): SearchOptions => searchOptionsSchema.parse(search),
  component: PatientSettingsPage,
});
